import React from 'react';
import '../Colors.css';

const SearchPlus = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.46 283.46" enableBackground="new 0 0 283.46 283.46" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g id="bkg" display="none">
      </g>
      <g id="picto">
        <path className='HslBlue' d="M252.955,278.402l-72.063-72.062l25.447-25.448l72.063,72.063c7.023,7.023,7.023,18.409,0,25.432
          l-0.015,0.015C271.364,285.425,259.978,285.425,252.955,278.402z"/>
        <path className='HslBlue' d="M120.904,35.779c46.938,0,85.125,38.187,85.125,85.125c0,46.937-38.187,85.124-85.125,85.124
          s-85.125-38.186-85.125-85.124C35.779,73.966,73.966,35.779,120.904,35.779 M120.904-0.209
          C54.015-0.209-0.209,54.015-0.209,120.904s54.224,121.112,121.113,121.112s121.113-54.223,121.113-121.112
          S187.793-0.209,120.904-0.209L120.904-0.209z"/>
        <path className='HslGreen' d="M64.211,120.904L64.211,120.904c0-7.828,6.346-14.173,14.173-14.173h85.039
          c7.828,0,14.173,6.346,14.173,14.173v0c0,7.828-6.346,14.173-14.173,14.173H78.384C70.556,135.077,64.211,128.731,64.211,120.904z"/>
        <path className='HslGreen' d="M120.904,64.211L120.904,64.211c7.828,0,14.173,6.346,14.173,14.173v85.039
          c0,7.828-6.346,14.173-14.173,14.173h0c-7.828,0-14.173-6.346-14.173-14.173V78.384C106.731,70.556,113.076,64.211,120.904,64.211z"/>
      </g>
    </svg>
  );
};

export default SearchPlus;